import React, { useEffect, useState } from "react";
import ReportsTab from "./ReportsTab";
import { useDispatch, useSelector } from "react-redux";
import { getTrip } from "redux/actions/UserTrip";
import { getBooking } from "redux/actions/UserReport";
import { getRideAnalytic } from "redux/actions/UserDashboard";
import { useNavigate } from "react-router-dom";

function Reports() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [value, setValue] = useState("Ride");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  const bookingData = useSelector(
    (state) => state?.userBooking?.userBooking?.data
  );
  const loaderBooking = useSelector((state) => state?.userBooking?.loading);
  const rideAnalytic =
    useSelector((state) => state?.userRideAnalytic?.userRideAnalytic?.data) ||
    {};
  const isLoadingRideAnalytic = useSelector(
    (state) => state?.userRideAnalytic.loading
  );

  let filterData = {
    id: "",
    page: page,
    dateFrom: "",
    dateTo: "",
    status: "",
    pageSize: rowsPerPage,
    type: "",
    search: "",
  };

  const titleData = {
    barTitle: "Booking Reports",
    doughnutTitle: "Booking Status",
  };

  const handleChange = (newValue) => {
    if (newValue == "Ride") {
      dispatch(getTrip({ ...filterData, type: "Ride" }));
      dispatch(getBooking({ type: "ride" }));
      dispatch(getRideAnalytic({ type: "ride" }));
    } else {
      dispatch(getTrip({ ...filterData, type: "Rental" }));
      dispatch(getBooking({ type: "rental" }));
      dispatch(getRideAnalytic({ type: "rental" }));
    }
    setValue(newValue);
  };

  useEffect(() => {
    dispatch(getTrip({ ...filterData, type: "Ride" }));
    dispatch(getBooking({ type: "ride" }));
    dispatch(getRideAnalytic({ type: "ride" }));
  }, []);

  const handleChangePage = (newPage) => {
    setPage(newPage);
    dispatch(getTrip({ ...filterData, page: newPage }));
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getTrip({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const onClickTableVendor = (data) => {
    navigate("/rideTrack/details", {
      state: {
        id: data?.id,
        status: data?.status,
        customer: data?.customerName,
        driver: data?.driverName,
        value,
        tripId: data?.tripId,
      },
    });
  };

  return (
    <>
      <ReportsTab
        loader={loader}
        handleChange={handleChange}
        value={value}
        titleData={titleData}
        rideTrackData={tableData}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        page={page}
        rowsPerPage={rowsPerPage}
        bookingData={bookingData}
        loaderBooking={loaderBooking}
        isLoadingRideAnalytic={isLoadingRideAnalytic}
        rideAnalytic={rideAnalytic}
        onClickTableVendor={onClickTableVendor}
      />
    </>
  );
}

export default Reports;
